import React, { ReactNode, RefObject } from 'react';
import btnSearch from '../../../img/accountManagement/btn_rechercher.svg';

type Props = {
  placeholder: string;
  onChange: (string) => void;
  inputRef?: RefObject<HTMLInputElement>;
  noIcon?: boolean;
};

type State = {
  isOpen: boolean
};

class SearchButton extends React.Component<Props, State> {
  state: State = {
    isOpen: false,
  };

  toogleOpen = (): void => this.setState((previousState) => ({ isOpen: !previousState.isOpen }));

  render(): ReactNode {
    return (
      <div className={`search-button${this.state.isOpen ? ' open' : ''}`}>
        <button
          className="icon-button icon"
          type="button"
          onClick={this.toogleOpen}
        >
          <img alt="button-leave" src={btnSearch} />
        </button>
        <input
          type="text"
          ref={this.props.inputRef}
          className={`search-input-field ${this.state.isOpen ? '' : 'hide'}`}
          placeholder={this.props.placeholder}
          onChange={(event) => this.props.onChange(event.target.value)}
        />
      </div>
    );
  }
}

export default SearchButton;
